import * as React from 'react';
import { connect } from 'react-redux';
import { NavLink, Redirect } from 'react-router-dom';
import { signupRequest } from '../actions/auth';
import * as Recaptcha from 'react-recaptcha';
import { withTranslation } from 'react-i18next';
import Helmet from 'react-helmet';

interface IInputs {
    username: string,
    password: string,
    first: string,
    last: string,
    email: string,
    confirm_password: string,
    gender: number,
    agreement: boolean | string,
    file?: File,
    verify? : string,
    [key: string]: any
};

interface IState {
    inputs: IInputs,
    errors: IInputs,
    redirectToCabinet: boolean,
    isLoading: boolean,
    isVerified: boolean,
    [key: string]: any
};

class Signup extends React.Component<any, any> {
    public state: IState = {
        inputs: {
            username: "",
            password: "",
            first: "",
            last: "",
            email: "",
            confirm_password: "",
            gender: 0,
            agreement: ""
        },
        errors: {
            username: "",
            password: "",
            first: "",
            last: "",
            email: "",
            confirm_password: "",
            gender: 0,
            agreement: "",
            verify: ""
        },
        redirectToCabinet: false,
        isLoading: false,
        isVerified: false,
    }

    validateInput(name: string, value: string) {

        return new Promise<any>((ok: any, error: any): any => {
            this.setState({
                errors: {
                    ...this.state.errors,
                    [name]: value == "" ? (this.props.t("Необходимо заполнить") + " «" + this.props.t(name) + "»") : ""
                }
            }, () => {
                ok();
            });
        });
    }

    changeHandler(event: any) {
        let name = event.target.name;
        let value = event.target.value;

        console.log(event.target.files);

        if (name == "agreement") {
            this.setState({
                errors: {
                    ...this.state.errors,
                    agreement: !event.target.checked ? this.props.t("Нужно согласиться") : ""
                },
                inputs: {
                    ...this.state.inputs,
                    agreement: event.target.checked
                }
            });
        } else if (name == "file") {
            this.setState({
                inputs: {
                    ...this.state.inputs,
                    [name]: event.target.files.length > 0 ? event.target.files[0] : null
                }
            });
        } else {
            this.setState({
                inputs: {
                    ...this.state.inputs,
                    [name]: value
                }
            });
        }
    }

    blurHandler(event: any) {
        let name = event.target.name;
        let value = event.target.value;

        this.validateInput(name, value).then(() => {
            if (name == "confirm_password" && value != "" && this.state.inputs.password != this.state.inputs.confirm_password) {
                this.setState({
                    errors: {
                        ...this.state.errors,
                        confirm_password: this.props.t("Пароли не совпадают")
                    }
                })
            }
        });
    }

    async submitHandler(event: any) {
        let hasError = false;

        for (let property in this.state.inputs) {
            if (property != "gender" && property != "agreement")
                await this.validateInput(property, this.state.inputs[property]);
        }

        if (this.state.inputs.password != this.state.inputs.confirm_password) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    confirm_password: this.props.t("Пароли не совпадают")
                }
            })
        }

        if (!this.state.inputs.agreement) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    agreement: this.props.t("Нужно согласиться")
                }
            })
        }

        if (!this.state.isVerified) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    verify: this.props.t("Подтвердите капчу")
                }
            })
        }

        for (let property in this.state.errors) {
            if (this.state.errors[property] != "") {
                hasError = true;
                break;
            }
        }

        

        if (!hasError && !this.state.isLoading && this.state.isVerified) {
            this.setState({
                isLoading: true
            }, async () => {
                let formData = new FormData();
                formData.append('data', JSON.stringify(this.state.inputs));
                formData.append('image', this.state.inputs.file);

                let response = await this.props
                    .signupRequest(formData);

                if (response.data.status == "error") {
                    let errors: any = {};

                    for (let prop in response.data.errors) {
                        errors[prop] = response.data.errors[prop].join(", ");
                    }
                    this.setState({
                        errors,
                        isLoading: false
                    });
                } else {
                    this.setState({
                        isLoading: false
                    });
                }
            });
        }
    }

    render() {
        const {t} = this.props;

        return (
            <div className="i-body">
                <Helmet>
                    <title>{t("Регистрация") + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>
                </Helmet>
                
                <div className="container login-page v-index">
                    {(this.props.auth.isAuthentificated) && <Redirect to="/" />}
                    <div className="wrapper">
                        <div className="box" >
                            <div className="row">
                                <div className="col-lg-4 col-lg-push-4">
                                    <h2 className="text-header text-center">{t("Регистрация")}</h2>
                                    <form id="official-signup" onSubmit={async (e: any) => {
                                        e.preventDefault();

                                        await this.submitHandler(e);
                                    }}>
                                        <div className="form-group">
                                            <input type="text" id="signupform-first" className="form-control" name="first" onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.blurHandler(e)} value={this.state.inputs.first} placeholder={t("Имя *")} />
                                            <p className="help-block help-block-error text-danger">{this.state.errors.first}</p>
                                        </div>
                                        <div className="form-group">
                                            <input type="text" id="signupform-last" className="form-control" name="last" onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.blurHandler(e)} value={this.state.inputs.last} placeholder={t("Фамилия *")} />
                                            <p className="help-block help-block-error text-danger">{this.state.errors.last}</p>
                                        </div>
                                        <div className="form-group">
                                            <input type="text" id="signupform-username" className="form-control" name="username" onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.blurHandler(e)} value={this.state.inputs.username} placeholder={t("Логин *")} />
                                            <p className="help-block help-block-error text-danger">{this.state.errors.username}</p>
                                        </div>
                                        <div className="form-group">
                                            <input type="email" id="signupform-email" className="form-control" name="email" onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.blurHandler(e)} value={this.state.inputs.email} placeholder={t("Email *")} />
                                            <p className="help-block help-block-error text-danger">{this.state.errors.email}</p>
                                        </div>
                                        <div className="form-group">
                                            <input type="password" id="signupform-password" className="form-control" name="password" onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.blurHandler(e)} value={this.state.inputs.password} placeholder={t("Пароль *")} />
                                            <p className="help-block help-block-error text-danger">{this.state.errors.password}</p>
                                        </div>
                                        <div className="form-group">
                                            <input type="password" id="signupform-confirm_password" className="form-control" name="confirm_password" onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.blurHandler(e)} value={this.state.inputs.confirm_password} placeholder={t("Повторите пароль *")} />
                                            <p className="help-block help-block-error text-danger">{this.state.errors.confirm_password}</p>
                                        </div>
                                        <div className="form-group">
                                            <label className="radio-inline">
                                                <input type="radio" checked={this.state.inputs.gender == 0} name="gender" onChange={(e: any) => this.changeHandler(e)} id="inlineRadio1" value="0" /> {t("Мужщина")}
								            </label>
                                            <label className="radio-inline">
                                                <input type="radio" checked={this.state.inputs.gender == 1} name="gender" onChange={(e: any) => this.changeHandler(e)} id="inlineRadio2" value="1" /> {t("Женщина")}
								            </label>
                                        </div>
                                        <div className="form-group field-signupform-file">
                                            <label className="custom-file w-100 mb-0">
                                                <input type="file" id="signupform-file" className="border-0 custom-file-input" name="file" onChange={(e: any) => this.changeHandler(e)} />
                                                <span className="custom-file-control form-control-file"></span>
                                                <span className="">
                                                    <p className="help-block help-block-error text-danger" ></p>
                                                </span>
                                            </label>
                                        </div>

                                        <div className="form-group">
                                            <label className="custom-control custom-radio pt-3">
                                                <input type="checkbox" id="signupform-agreement" className="custom-control-input" onChange={(e: any) => this.changeHandler(e)} value={"agree"} name="agreement" />
                                                <span className="custom-control-indicator mt-3"></span>
                                                <span className="custom-control-description">
                                                    {" "} {t("Я согласен с")} <NavLink to="/agreement" className="text-danger">{t("Условия и правила")}</NavLink>
                                                </span>
                                            </label>
                                            <p className="help-block help-block-error text-danger">{this.state.errors.agreement}</p>
                                        </div>
                                        
                                        <Recaptcha sitekey="6LdX0qkUAAAAAPMnTMId2dXWqIfOP3H-TT6qbrsN" render="explicit" onloadCallback={() => {

                                        }} verifyCallback={(response: string) => {
                                            this.setState({
                                                isVerified: true,
                                                errors: {
                                                    ...this.state.errors,
                                                    verify: ""
                                                }
                                            });
                                        }}/>
                                        <p className="help-block help-block-error text-danger">{this.state.errors.verify}</p>

                                        <button type="submit" className="btn btn-success mt-10">{this.state.isLoading ? (
                                            <i className="fa fa-spinner fa-2x rotating "></i>
                                        ) : t("Регистрация")}</button>
                                    </form>
                                </div>
                            </div>
                            <div className="w-100 text-center text-description mt-20">
                                {t("У вас есть аккаунт?")} {" "}
                                <NavLink className="text-success" to="/login"> <b> {t("Войти")} </b> </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        auth: state.auth
    };
}

export default connect(mapStateToProps, { signupRequest })(withTranslation()(Signup));